<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'wbs',

    metaInfo: { title: 'Whistleblowing' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'wbs',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'wbs',
      },
    },
  }
</script>
